// @ts-nocheck

import debounce from 'lodash/debounce'

const SET_SORT_BY = 'SET_SORT_BY'
const SET_SORT_ORDER = 'SET_SORT_ORDER'
const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
const SET_LOADING = 'SET_LOADING'
const SET_PAGES_WITH_DATA = 'SET_PAGES_WITH_DATA'
const SET_PAGE_DATA = 'SET_PAGE_DATA'
const SET_PAGINATION = 'SET_PAGINATION'

export const getPaginationModule = (fetchFunction, normalizeFunction, defaults = {}) => {
  const debouncedDispatch = debounce(
    (dispatch, action, parameters) => dispatch(action, parameters),
    2000,
    {
      leading: true,
      trailing: true,
    },
  )

  return {
    namespaced: true,
    state: {
      pagesWithData: [],
      sortBy: defaults.sortBy || '',
      sortOrder: defaults.sortOrder || 'desc',
      searchQuery: defaults.searchQuery || '',
      pagination: {
        currentPage: 1,
        perPage: 1,
        lastPage: 1,
        total: 0,
      },
      loading: false,
    },
    getters: {
      pagesWithData: (state) => state.pagesWithData,
      loading: (state) => state.loading,
      sortBy: (state) => state.sortBy,
      sortOrder: (state) => state.sortOrder,
      searchQuery: (state) => state.searchQuery,
      pagination: (state) => state.pagination,
    },
    mutations: {
      [SET_PAGES_WITH_DATA]: (state, pagesWithData) => (state.pagesWithData = pagesWithData),
      [SET_PAGE_DATA]: (state, { page, data }) => (state.pagesWithData[page] = data),
      [SET_LOADING]: (state, loading) => (state.loading = loading),
      [SET_SORT_BY]: (state, sortBy) => (state.sortBy = sortBy),
      [SET_SORT_ORDER]: (state, sortOrder) => (state.sortOrder = sortOrder),
      [SET_SEARCH_QUERY]: (state, searchQuery) => (state.searchQuery = searchQuery),
      [SET_PAGINATION]: (state, pagination) => (state.pagination = pagination),
    },
    actions: {
      initModule({ dispatch }) {
        dispatch('fetchData', { clear: true })
      },
      fetchData({ dispatch }, parameters) {
        debouncedDispatch(dispatch, 'internalFetchData', parameters)
      },
      internalFetchData({ rootState, commit, state }, { clear } = {}) {
        commit(SET_LOADING, true)
        const dateRange = rootState.user.dataDateRange
        const page = clear ? 1 : state.pagination.currentPage
        fetchFunction(
          rootState.user.token,
          rootState.shop.shop.id,
          { from: dateRange.start, to: dateRange.end },
          page,
          state.sortBy,
          state.sortOrder,
          state.searchQuery,
        ).then(({ data }) => {
          const normalizedData = normalizeFunction(data.data)
          if (clear || state.pagesWithData.length === 0) {
            const pages = new Array(data.last_page + 1).fill([])
            pages[data.current_page] = normalizedData
            commit(SET_PAGES_WITH_DATA, pages)
          }
          commit(SET_PAGE_DATA, {
            page: data.current_page,
            data: normalizedData,
          })
          commit(SET_LOADING, false)
          commit(SET_PAGINATION, {
            currentPage: data.current_page,
            lastPage: data.last_page,
            perPage: data.per_page,
            total: data.total,
          })
        })
      },
      changePage({ commit, dispatch, state }, page) {
        commit(SET_PAGINATION, { ...state.pagination, currentPage: page })
        if (state.pagesWithData.length === 0 || state.pagesWithData[page]?.length === 0) {
          dispatch('fetchData')
        }
      },
      changeSort({ commit, dispatch, state }, { sortBy, sortOrder }) {
        if (state.sortBy !== sortBy || state.sortOrder != sortOrder) {
          commit(SET_SORT_BY, sortBy)
          commit(SET_SORT_ORDER, sortOrder)
          dispatch('fetchData', { clear: true })
        }
      },
      changeSearchQuery({ commit, dispatch, state }, searchQuery) {
        if (state.searchQuery !== searchQuery) {
          commit(SET_SEARCH_QUERY, searchQuery)
          dispatch('fetchData', { clear: true })
        }
      },
      setPageData({ commit }, { page, data }) {
        commit(SET_PAGE_DATA, { page, data })
      },
    },
  }
}
